export default __webpack_public_path__ + "static/madagascar-a5596275c4f1b62973c011b0f73b4783.jpg";